<template>
    <v-row no-gutters>
        <v-col cols="12" sm="10" offset-sm="1">
            <span class="headline">Korisnici</span>
            <bit-page :breadcrumbs="breadcrumbs"></bit-page>
            <v-row align="center" class="white mt-3 pa-3" no-gutters>
                <span class="title green--text text--darken-3">Meni</span>
                <v-col class="d-flex mb-3" cols="12">
                    <v-divider></v-divider>
                </v-col>
                <v-col class="d-flex mt-3" cols="12">
                    <v-btn depressed small tile color="success" :to="{name: 'korisnici-create'}">Dodaj novog korisnika</v-btn>
                </v-col>
                <v-col class="d-flex mt-3" cols="12">
                    <v-data-table
                            class="mt-4"
                            style="width: 100%;border: 1px solid #ddd;border-radius: 0"
                            :headers="headers"
                            :items="items"
                    >
                        <template v-slot:item.option="{ item }">
                            <v-btn icon :to="{name: 'korisnici-create', params: {item: item}}">
                                <v-icon small>{{'mdi-pencil'}}</v-icon>
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
	import bitPage from "../../components/layout/page";

	export default {
		components: {
			bitPage
		},
		head() {
			return {
				title: 'BitLab CMS'
			}
		},
		data: () => ({
			breadcrumbs: [
				{
					text: 'Meni',
					disabled: true
				},
			],
			headers: [
				{text: 'ID', value: 'id'},
				{text: 'Name', value: 'name'},
				{text: 'E-Mail', value: 'email'},
				{text: 'Option', value: 'option'},
			],
			items: []
		}),
        created() {
		    this.getUser();
        },
        methods: {
		    getUser() {
		        this.axios.get('/user').then(res => {
		            this.items = res.data
                })
            }
        }
	}
</script>
